import { handleActions } from 'redux-actions'

import {
    GET_ALL_OBJECT_TYPES,
} from '@/store/actions/dictionaries'

const initialState = {
    data: [],
}

export const reducer = handleActions(
    {
        [GET_ALL_OBJECT_TYPES.SUCCESS]: (state, { payload }) => ({
            ...state,
            data: payload,
        }),
        [GET_ALL_OBJECT_TYPES.ERROR]: (state) => ({
            ...state,
        }),
    },
    initialState,
)

export default reducer
